// START OF CUSTOMIZED JAVASCRIPT CODE

// Code Calory Burner Tool
function initTool() {
  if (!document.getElementById("customized__tool__calories")) {
    return;
  }

  const toolResult = document.querySelector(".customized__tool__result");
  const duration = document.getElementById("duration");
  const bodyweight = document.getElementById("bodyweight");
  const genderHintButtons = document.querySelectorAll(
    ".customized__tool__gender-hint-button"
  );
  const gender = [
    ...document.querySelectorAll(
      ".customized__tool__radiobtn-group input[type=radio]"
    ),
  ];
  const intensity = document.getElementById("intensity");

  // Populate unit elements with their respective initial values
  const initialValues = (...elements) => {
    elements.forEach((element) => {
      const originalValue = element.value;
      const span = element.nextElementSibling;
      return (span.textContent = originalValue);
    });
  };

  // Dynamically update selected input range values
  const showSelection = (event) => {
    const span = event.target.nextElementSibling;
    return (span.textContent = `${event.target.value}`);
  };

  const getGenderSelection = () => {
    return gender
      .filter((choice) => {
        if (choice.checked) {
          return choice;
        }
      })
      .map((choice) => choice.dataset.factor)
      .join();
  };
  const handleToolTipGender = (event) => {
    event.preventDefault();
    const genderHintParentElement = document.querySelector(
      ".customized__tool__gender-hint"
    );
    return genderHintParentElement.classList.toggle("active");
  };

  const calculateCalories = () => {
    // event.preventDefault();
    // Required values for calculation of the MET formula. Factor A changes accordingly to gender. Factor B is given by the MET formula.
    const FACTOR_A = getGenderSelection();
    const FACTOR_B = 200;
    const bw = bodyweight.value;
    const du = duration.value;
    const intensitySelection = intensity.value;

    const firstStep = calculationStep1(
      intensitySelection,
      FACTOR_A,
      bw,
      FACTOR_B
    );
    const secondStep = calculationStep2(firstStep, du);
    return (toolResult.textContent = `${secondStep} kcal`);
  };

  const calculationStep1 = (intensityLevel, factorA, weight, factorB) => {
    const toolResult = (intensityLevel * factorA * weight) / factorB;
    return toolResult;
  };

  const calculationStep2 = (prevCalc, duration) => {
    const toolResult = prevCalc * duration;
    return Number.parseFloat(toolResult).toFixed(0);
  };

  const calculate = (event) => {
    if (event.target === duration || event.target === bodyweight) {
      showSelection(event);
    }
    return calculateCalories();
  };

  window.addEventListener("DOMContentLoaded", calculateCalories);
  window.addEventListener("DOMContentLoaded", () => {
    initialValues(duration, bodyweight);
  });

  duration.addEventListener("change", calculate);
  bodyweight.addEventListener("change", calculate);
  gender.forEach((button) => button.addEventListener("click", calculate));
  intensity.addEventListener("change", calculate);
  genderHintButtons.forEach((button) =>
    button.addEventListener("click", handleToolTipGender)
  );
}

initTool();

// Customized styling of sticky cart button
const customizeStickyCartBtn = () => {
  const stickyCartBtn = document.querySelector(".sticky-cart-button");
  stickyCartBtn.removeAttribute("style");
};

window.addEventListener("load", () => {
  if (!document.querySelector(".sticky-cart-button")) {
    return;
  } else {
    customizeStickyCartBtn();
  }
});

// JS Buy Button Blog Posts Integration
function init_JSBuyButtonIntegration() {
  const config = {
    blogPostContainer: getBlogContainerElement(
      ".customized__article-product-cart"
    ),
    colorBrandAccent: "#36dfb3",
    colorBrandAccentHover: "#62e6c4",
    id: createNewId(),
    isParent: true,
    defaultProductId: "3811089907786",
    scriptUrl:
      "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js",
    targetElement: ".customized__article-product-cart-buy-button",
  };

  function getBlogContainerElement(query) {
    return document.querySelector(query);
  }

  function loadScript() {
    const script = document.createElement("script");
    script.async = true;
    script.src = config.scriptUrl;
    (
      document.getElementsByTagName("head")[0] ||
      document.getElementsByTagName("body")[0]
    ).appendChild(script);
    script.onload = ShopifyBuyInit;
  }

  function createNewId() {
    return Math.floor(Math.random() * 1000000);
  }

  function getTargetElement(container) {
    return container.querySelector(config.targetElement);
  }

  function createBuyButtonWrapper(id) {
    const buyButtonWrapper = document.createElement("div");
    buyButtonWrapper.classList.add("customized__js-buy-button-wrapper");
    buyButtonWrapper.id = `product-component-${id}`;
    return buyButtonWrapper;
  }

  function appendBuyButtonWrapper(id) {
    const buyButtonWrapper = createBuyButtonWrapper(id);
    const firstTargetElement = getTargetElement(config.blogPostContainer);
    if (config.isParent) {
      firstTargetElement.appendChild(buyButtonWrapper);
    } else {
      firstTargetElement.before(buyButtonWrapper);
    }
  }

  function getProductHandle(container) {
    return container.dataset.productIdHandle;
  }

  function setProductId() {
    let productId = getProductHandle(config.blogPostContainer);
    if (!productId) {
      return config.defaultProductId;
    }
    if (typeof productId !== "string") {
      productId = productId.toString();
    }
    return productId;
  }

  function ShopifyBuyInit() {
    const client = ShopifyBuy.buildClient({
      domain: "pallid-falcon.myshopify.com",
      storefrontAccessToken: "7135420a1f699a5ef5c08bf858d888c1",
    });

    const productId = setProductId();

    ShopifyBuy.UI.onReady(client).then(function (ui) {
      ui.createComponent("product", {
        id: productId,
        moneyFormat: "%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D",
        node: document.getElementById(`product-component-${config.id}`),
        options: {
          product: {
            styles: {
              product: {
                "@media (min-width: 601px)": {
                  "max-width": "calc(25% - 20px)",
                  "margin-left": "20px",
                  "margin-bottom": "50px",
                },
              },
              button: {
                "font-family": "Roboto, sans-serif",
                "font-weight": "bold",
                ":hover": {
                  "background-color": `${config.colorBrandAccentHover}`,
                },
                "background-color": `${config.colorBrandAccent}`,
                ":focus": {
                  "background-color": `${config.colorBrandAccentHover}`,
                },
                "border-radius": "40px",
                "padding-left": "1rem",
                "padding-right": "1rem",
                width: "100%",
              },
              title: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "400",
                "letter-spacing": "0.025em",
                "text-transform": "uppercase",
              },
              price: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
              },
              compareAt: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
              },
              unitPrice: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
              },
            },
            text: {
              button: "In den Warenkorb",
            },
            googleFonts: ["Oswald", "Roboto"],
          },
          productSet: {
            styles: {
              products: {
                "@media (min-width: 601px)": {
                  "margin-left": "-20px",
                },
              },
            },
          },
          modalProduct: {
            contents: {
              img: false,
              imgWithCarousel: true,
              button: false,
              buttonWithQuantity: true,
            },
            styles: {
              product: {
                "@media (min-width: 601px)": {
                  "max-width": "100%",
                  "margin-left": "0px",
                  "margin-bottom": "0px",
                },
              },
              button: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                ":hover": {
                  "background-color": `${config.colorBrandAccentHover}`,
                },
                "background-color": `${config.colorBrandAccent}`,
                ":focus": {
                  "background-color": `${config.colorBrandAccentHover}`,
                },
                "border-radius": "40px",
                "padding-left": "86px",
                "padding-right": "86px",
              },
              title: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                "font-size": "26px",
                color: "#4c4c4c",
              },
              price: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "normal",
                "font-size": "18px",
                color: "#4c4c4c",
              },
              compareAt: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "normal",
                "font-size": "15.299999999999999px",
                color: "#4c4c4c",
              },
              unitPrice: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "normal",
                "font-size": "15.299999999999999px",
                color: "#4c4c4c",
              },
            },
            googleFonts: ["Oswald"],
            text: {
              button: "zum Warenkorb hinzufügen",
            },
          },
          option: {},
          cart: {
            styles: {
              button: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                ":hover": {
                  "background-color": `${config.colorBrandAccentHover}`,
                },
                "background-color": `${config.colorBrandAccent}`,
                ":focus": {
                  "background-color": `${config.colorBrandAccentHover}`,
                },
                "border-radius": "40px",
              },
              title: {
                color: "#000000",
              },
              header: {
                color: "#000000",
              },
              lineItems: {
                color: "#000000",
              },
              subtotalText: {
                color: "#000000",
              },
              subtotal: {
                color: "#000000",
              },
              notice: {
                color: "#000000",
              },
              currency: {
                color: "#000000",
              },
              close: {
                color: "#000000",
                ":hover": {
                  color: "#000000",
                },
              },
              empty: {
                color: "#000000",
              },
              noteDescription: {
                color: "#000000",
              },
              discountText: {
                color: "#000000",
              },
              discountIcon: {
                fill: "#000000",
              },
              discountAmount: {
                color: "#000000",
              },
            },
            text: {
              title: "Warenkorb",
              total: "Zwischensumme inkl. MwSt. zzgl. Versandkosten",
              empty: "Dein Warenkorb ist leer.",
              notice:
                "Ich habe die AGB gelesen und bin mit deren Geltung einverstanden. Bitte beachte bei Deiner Bestellung auch unsere Widerrufsbelehrung und unsere Datenschutzerklärung.",
              button: "Verschlüsselt zur Kasse",
            },
            popup: false,
            googleFonts: ["Oswald"],
          },
          toggle: {
            styles: {
              toggle: {
                "font-family": "Oswald, sans-serif",
                "font-weight": "bold",
                "background-color": `${config.colorBrandAccent}`,
                ":hover": {
                  "background-color": `${config.colorBrandAccentHover}`,
                },
                ":focus": {
                  "background-color": `${config.colorBrandAccentHover}`,
                },
              },
            },
            googleFonts: ["Oswald"],
          },
          lineItem: {
            styles: {
              variantTitle: {
                color: "#000000",
              },
              title: {
                color: "#000000",
              },
              price: {
                color: "#000000",
              },
              fullPrice: {
                color: "#000000",
              },
              discount: {
                color: "#000000",
              },
              discountIcon: {
                fill: "#000000",
              },
              quantity: {
                color: "#000000",
              },
              quantityIncrement: {
                color: "#000000",
                "border-color": "#000000",
              },
              quantityDecrement: {
                color: "#000000",
                "border-color": "#000000",
              },
              quantityInput: {
                color: "#000000",
                "border-color": "#000000",
              },
            },
          },
        },
      });
    });
  }

  // Only run when page contains config.blogPostContainer
  function runJSBuyButtonIntegration(id) {
    if (!config.blogPostContainer) return;

    appendBuyButtonWrapper(id);

    if (window.ShopifyBuy) {
      if (window.ShopifyBuy.UI) {
        ShopifyBuyInit();
      } else {
        loadScript();
      }
    }
  }

  runJSBuyButtonIntegration(config.id);
}

init_JSBuyButtonIntegration();

// TOC for customized article section
const tocButton = document.querySelector(".customized__toc__button");

const configToC = {
  rootElementId: "customized__toc",
  selector: ["h2, h3"],
  scope: ".customized__article-content",
  tocHeading: "Inhaltsverzeichnis",
  tocHeadingSelector: ".customized__toc__name",
  tocLinkClass: "customized__toc--link",
};

const setIdHeadingElements = (headings) => {
  headings.forEach((heading) => (heading.id = slugify(heading.textContent)));
};

const headings = (nestedHeadings) => {
  const toc = buildToc(nestedHeadings);
  document.querySelector(configToC.tocHeadingSelector).after(toc);
};

const buildToc = (nestedHeadings) => {
  document.querySelector(configToC.tocHeadingSelector).textContent =
    configToC.tocHeading;
  const firstLevelOl = document.createElement("ol");
  nestedHeadings.forEach((heading) => {
    const firstLevelLi = document.createElement("li");
    const a = document.createElement("a");
    a.href = `#${heading.id}`;
    a.textContent = heading.title.toLowerCase();
    a.classList.add(configToC.tocLinkClass);
    firstLevelLi.append(a);
    firstLevelOl.append(firstLevelLi);
    const secondLevelOl = document.createElement("ol");
    if (heading.items.length > 0) {
      const thirdLevelOl = document.createElement("ol");
      heading.items.forEach((item) => {
        const secondLevelLi = document.createElement("li");
        const a = document.createElement("a");
        a.href = `#${item.id}`;
        a.textContent = item.title.toLowerCase();
        a.classList.add(configToC.tocLinkClass);

        secondLevelLi.append(a);
        secondLevelOl.append(secondLevelLi);
        if (item.items.length > 0) {
          item.items.forEach((subitem) => {
            const thirdLevelLi = document.createElement("li");
            const a = document.createElement("a");
            a.href = `#${subitem.id}`;
            a.textContent = subitem.title.toLowerCase();
            a.classList.add(configToC.tocLinkClass);

            thirdLevelLi.append(a);
            thirdLevelOl.append(thirdLevelLi);
          });
          secondLevelOl.append(thirdLevelOl);
        }
      });
      firstLevelLi.append(secondLevelOl);
    }
  });
  return firstLevelOl;
};

function initToC(config) {
  if (!document.querySelector(config.scope)) return;
  const scope = document.querySelector(config.scope);
  const headingElements =
    Array.from(scope.querySelectorAll(config.selector)) ?? [];
  setIdHeadingElements(headingElements);
  const getNestedHeadings = (headingElements) => {
    const nestedHeadings = [];

    headingElements.forEach((heading, index) => {
      const { innerText: title, id, nodeName } = heading;
      if (heading.nodeName === "H2") {
        nestedHeadings.push({ id, nodeName, title, items: [] });
      } else if (heading.nodeName === "H3" && nestedHeadings.length > 0) {
        nestedHeadings[nestedHeadings.length - 1].items.push({
          id,
          nodeName,
          title,
          items: [],
        });
      } else if (heading.nodeName === "H4" && nestedHeadings.length > 0) {
        nestedHeadings[nestedHeadings.length - 1].items[
          nestedHeadings[nestedHeadings.length - 1].items.length - 1
        ].items.push({
          id,
          nodeName,
          title,
        });
      }
    });
    return nestedHeadings;
  };
  const nestedHeadings = getNestedHeadings(headingElements);
  headings(nestedHeadings);
  removeEmptyElements();
  // return (navListItems = [...nav.querySelectorAll("li")]);
}

initToC(configToC);

// UI FUNCTIONALITY
const toggleToc = (event) => {
  const toggleClass = "customized__js--toggle";
  const tocMenuContainer = event.currentTarget.nextElementSibling;
  tocMenuContainer.classList.toggle(toggleClass);
  const tocStatus = tocMenuContainer.classList.contains(toggleClass)
    ? "öffnen"
    : "schließen";
  return event.currentTarget.setAttribute(
    "title",
    `Inhaltsverzeichnis ${tocStatus}`
  );
};

// HELPERS
function slugify(slug) {
  const replaceValue = "-";
  const searchValue = /\s+/g;
  return slug.trim().replace(searchValue, replaceValue);
}

function removeEmptyElements() {
  // currently only empty p elements seem to pollute the article content flow
  const pElements = Array.from(
    document.querySelectorAll(`${configToC.scope} p`)
  );
  return pElements
    .filter((p) => p.innerHTML === "&nbsp;")
    .map((p) => p.remove());
}

// EVENTS + FUNCTION CALLS
window.addEventListener("DOMContentLoaded", () => {
  if (!tocButton) return;
  tocButton.addEventListener("click", (event) => toggleToc(event));
});
